export const JO = 'JO'

export const isJordanianAdmin = () => {
  const userData = JSON.parse(localStorage.getItem('userData'))
  const userCountry = userData.country || 'JO'
  //   const userCountry = 'LY'
  return userCountry === JO
}
